import { useSelect } from '~/store'
import { Organization } from '@st/sdk'
import { organizationModule } from './organization-module'

export function useOrganization(): Organization {
  const organization = useSelect('organization', (s) => s.organization)
  if (!organization) throw 'Organization not loaded'
  return organization
}
